<template>
  <div v-if="initialized" id="app"
       :class="{
         'environment-staging-border': environment === VITE_ENV_STAGING,
         'environment-development-border': environment === VITE_ENV_DEVELOPMENT,
         'environment-review-border': environment === VITE_ENV_REVIEW,
         'ziggu_sm': isMobile || isTablet, 'ziggu_lg': isDesktop
       }">
    <InvoiceOverdueBanner v-if="billing_current_client.attributes.invoice_overdue"
                          :billing="billing_current_client"/>
    <OutOfOfficeBanner
      v-if="current_client.attributes.ooo"
      :client="current_client"
      :profile="current_profile"/>
    <NavbarTablet v-if="(isMobile || isTablet)" :project_id="project_id"/>
    <NavbarDesktopClient v-if="isDesktop && !project_id"/>
    <NavbarDesktopProject v-if="isDesktop && project_id" />
    <TopbarDesktop v-if="isDesktop"/>
    <TopbarTablet v-else/>
    <main id="page" :class="{'sidebar-padding': isDesktopWide && sidebar_type }">
      <div class="section container is-widescreen">
        <router-view/>
      </div>
    </main>
  </div>
  <div v-else>
    <b-loading :active="!initialized" :is-full-page="true"/>
  </div>
</template>

<script>
import NavbarDesktopClient from '@/app/_employees/components/navbar/TheNavbarDesktopClient.vue';
import NavbarDesktopProject from '@/app/_employees/components/navbar/TheNavbarDesktopProject.vue';
import NavbarTablet from '@/app/_employees/components/navbar/TheNavbarTablet.vue';
import TopbarDesktop from '@/app/shared_components/navbar/TheTopbarDesktop.vue';
import TopbarTablet from '@/app/shared_components/navbar/TheTopbarTablet.vue';
import OutOfOfficeBanner from '@/app/shared_components/banner/TheOutOfOfficeBanner.vue';
import InvoiceOverdueBanner from '@/app/_employees/components/InvoiceOverdueBanner.vue';
import profile_mixin from '@/app/util/profile_mixin';

export default {
  name: 'Employee',
  components: {
    InvoiceOverdueBanner,
    NavbarDesktopClient,
    NavbarDesktopProject,
    NavbarTablet,
    OutOfOfficeBanner,
    TopbarDesktop,
    TopbarTablet,
  },
  mixins: [profile_mixin],

  async created() {
    await this.initProfile();
  },
};
</script>
